import React from 'react';

/**
 * Editorial marquee ribbon — "INORBIT ONE • LIVE AN EXPERIENCE •"
 * Slow scroll, blue base, yellow accents, italic serif type.
 */
export default function MarqueeRibbon({ items, testId = 'marquee-ribbon' }) {
    const phrases = items || [
        'INORBIT ONE',
        'LIVE AN EXPERIENCE',
        'ONE MALL IDENTITY',
        'POWERED BY FUNDLE.AI',
        'SIX PREMIUM DESTINATIONS',
        'EARN ACROSS EVERY INORBIT',
    ];
    const sequence = [...phrases, ...phrases]; // duplicate for seamless loop
    return (
        <div className="marquee-ribbon" data-testid={testId}>
            <div className="track">
                {sequence.map((p, i) => (
                    <span key={i} className="inline-flex items-center gap-10">
                        <span>{p}</span>
                        <span className="star">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
